import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { ApiKey } from '../components/enums'

export const reEvaluationRequestNSightPatch = async (data: object) => {
  return axios.put(endpoints.NSightPatchReEvaluationRequest, data)
}

export const useReEvaluationRequestNSightPatch = () => {
  const queryClient = useQueryClient()
  return useMutation(reEvaluationRequestNSightPatch, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.N_SIGHT_PATCH_Listing, ApiKey.list])
    },
  })
}
